<!-- .modal--show starts 'show' animation -->
<!-- .modal--hide starts 'hides' animation-->

<div>

  <div class="loading-overlay loading-overlay--fixed"></div>

  <div class="modal"
    [ngClass]="{'modal--show': popupOpen, 'modal--hide': !popupOpen}">
    <div class="modal-background"></div>

    <div class="modal-container" id="modal-add-comment">
      @if (data.isEditable) {
        @if (!hasComment) {
          <div>
            <h1 class="modal-title" i18n="Add comment@@add.comment.title">Add comment</h1>
            <p class="modal-subtitle" i18n="Add a comment to product@@add.comment.subtitle">Add a comment to "{{
						data.description }}"
					</p>
          </div>
        }
        @if (hasComment) {
          <div>
            <h1 class="modal-title" i18n="Edit comment@@edit.comment.title">Edit comment</h1>
            <p class="modal-subtitle"
              i18n="Edit your comment for product@@edit.comment.subtitle">Edit your comment
						for "{{ data.description }}"
					</p>
          </div>
        }
      }

      @if (!data.isEditable) {
        @if (hasComment) {
          <div>
            <h1 class="modal-title" i18n="Your comment@@your.comment.title">Your comment</h1>
            <p class="modal-subtitle"
              i18n="Your comment for product@@your.comment.subtitle">Your comment for "{{
						data.description }}"
					</p>
          </div>
        }
        @if (!hasComment) {
          <div>
            <h1 class="modal-title" i18n="No comment@@no.comment.title">No comment</h1>
            <p class="modal-subtitle"
              i18n="There is no comment for@@no.comment.subtitle">There is no comment for
						"{{ data.description }}"
					</p>
          </div>
        }
      }

      <div>
        <form [formGroup]="commentForm" (ngSubmit)="onSubmit(commentForm.value)">
          <div class="form-row">
            <textarea [formControl]="commentForm.controls['commentText']"
              [maxlength]="70"
              placeholder="Type your comment here"
              i18n-placeholder="Type your comment here@@add.comment.placeholder.text"
              maxlength="70">
            </textarea>
            <span i18n="max characters@@max.characters.comment">max 70 characters</span>
          </div>

          <div class="button-bar button-bar--right">
            <button type="button" class="button theme-btn-primary" (click)="close()"
              i18n="Close@@close.comment.button">
							Close
						</button>
            @if (data.isEditable) {
              <button type="submit" class="button button--green theme-btn-success"
                i18n="Save@@save.comment.button">
							Save
						</button>
            }
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
